import React, { useState, useEffect } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { SvgIcon } from "@montana/shared/svg-icon";
import cx from 'clsx';

export enum HeaderLogoSizes {
    Hidden = "hidden",
    Large = "large",
    Normal = "normal",
    Small = "small",
}

export interface IHeaderLogoProps {
    size: HeaderLogoSizes;
    inverted?: boolean;
    instant?: boolean;
    animate?: boolean;
}

export const HeaderLogo: React.FC<IHeaderLogoProps> = React.memo(({ size, inverted, instant = true, animate = false }: IHeaderLogoProps): JSX.Element => {
    const [activeLogoVariants, setActiveLogoVariants] = useState<IHeaderLogoProps[]>([]);

    useEffect(() => {
        setActiveLogoVariants([{
            size: size,
            inverted: inverted,
        }]);
    }, [inverted, size]);

    return (
        <>
            {
                animate ?
                    <TransitionGroup className="header-logo__wrapper">
                        {
                            activeLogoVariants.map(({ size, inverted }): JSX.Element => (
                                <CSSTransition
                                    appear
                                    key={`${size}${inverted}`}
                                    timeout={500}
                                    classNames="wipe"
                                >
                                    <div className={cx(`header-logo header-logo--${size}`, { 'header-logo--instant': instant })}>
                                        <div className="header-logo-inner">
                                            <SvgIcon iconName={`logo${inverted ? '_inverted' : ''}`} />
                                        </div>
                                    </div>
                                </CSSTransition>
                            ))
                        }
                    </TransitionGroup>
                    :
                    <div className={`header-logo header-logo--${size}`}>
                        <div className="header-logo-inner">
                            <SvgIcon iconName={`logo${inverted ? '_inverted' : ''}`} />
                        </div>
                    </div>
            }
        </>
    );
});
